import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../../components/Converter";
import PlusIcon from "../../../../../components/Icons/PlusIcon";
import Dash from "../../../../../components/Math/Units/Metric/Dash";
import { RowBody } from "../../../../../components/RowValue/RowBody";
import { decimalSeparator, thousandSeparator } from "../../../../../i18n";
import {
  selectAnzahlLastwechsel,
  setAnzahlLastwechsel,
} from "../../../../../store/slices/innereSlice";

function AnzahlLastwechsel({ show, showModal }) {
  const { t } = useTranslation("translation");
  const dispatch = useDispatch();

  const anzahlLastwechsel = useSelector(selectAnzahlLastwechsel);

  return (
    <RowBody
      titleValue={<p>{t("inner.fatigue.NumberLoadCycles")}</p>}
      indicesValue={
        <span>
          N<sub>R</sub>
        </span>
      }
      inputValue={
        <NumberFormat
          className={getClassName(anzahlLastwechsel)}
          value={anzahlLastwechsel}
          decimalSeparator={decimalSeparator()}
          thousandSeparator={thousandSeparator()}
          displayType="input"
          type="text"
          allowNegative={true}
          onValueChange={(value) => dispatch(setAnzahlLastwechsel(value.floatValue))}
        />
      }
      formulaValue={
        <div onClick={() => showModal(!show)}>
          <PlusIcon />
        </div>
      }
      unitValue={<Dash />}
    />
  );
}

export default AnzahlLastwechsel;
